const exchange = {
  enabledWallets: 'Wallet abilitati',
  exchange: 'Exchange',
  exchangeTxs: 'Transazioni di exchange',
};

export default exchange;
